import React from "react";
import { Segment } from "semantic-ui-react";

const styles = {
  message: {
    fontSize: "16px"
  },
  segment: { margin: 0 }
};

const SignupCompletedPage = () => {
  return (
    <Segment style={styles.segment}>
      <h1>Felicidades! Su registro está casi completo.</h1>
      <p style={styles.message}>
        En poco tiempo le estaremos informando cuando su cuenta esté habilitada
        para ingresar a la nueva aplicación. Su solicitud está en proceso.
      </p>
      <p style={styles.message}>
        Muchas gracias por utilizar los servicios del Laboratorio Médico las
        Américas.
      </p>
    </Segment>
  );
};

export default SignupCompletedPage;
